import { render, staticRenderFns } from "./ToggleLessonCategoryDialog.vue?vue&type=template&id=37a3bf8c"
import script from "./ToggleLessonCategoryDialog.vue?vue&type=script&lang=js"
export * from "./ToggleLessonCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports